import React, { useState } from 'react';
import { postDataAPI, putDataAPI } from '../../Helpers/FetchAPI';
import { Field, Form, Formik } from 'formik';
import Button from '../Button';
import { PreviousNoteGroup } from '../❉molecules/PreviousNoteGroup';
import useUser from '../../Hooks/useUser';
import toast from 'react-hot-toast';
import { useWindowSize } from 'react-use';
import {useTranslation} from "react-i18next";

export function ToolDrawerNote(props: {
  user: null,
  creditId: string,
  workbookId: string,
}) {
  const { currentUser } = useUser();
  const { width } = useWindowSize();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [lastSubmit, setLastSubmit] = useState(null);
  const [currentEntry, setCurrentEntry] = useState(null);
  const { t } = useTranslation();
  const handleClearNote = () => {
    setCurrentEntry(null);
    setTitle('');
    setContent('');
  };
  const handleSelectEntry = (entry) => {
    setCurrentEntry(entry);
    setTitle(entry.title);
    setContent(entry.content);
  };

  const handleSubmitEntry = () => {
    if (currentEntry) {
      toast.promise(
        putDataAPI(`/api/notebook/${currentEntry._id}/entry`, {
          user_id: currentUser?._id,
          entry: content,
          title: title
        }).then((res) => {
          setCurrentEntry(res.data.data);
          setLastSubmit(Date.now());
        }),
        { loading: t('Saving...'), success: t('Saved'), error: t('Failed to save') },
        { id: 'note_save', position: width > 700 ? 'bottom-right' : 'bottom-center' }
      );
    } else {
      toast.promise(
        postDataAPI(`/api/notebook/`, {
          workbookId: props.workbookId,
          entry: content,
          title: title,
          creditId: props.creditId,
          user_id: currentUser?._id
        }).then((res) => {
          setCurrentEntry(res.data.data);
          setLastSubmit(Date.now());
        }),
          { loading: t('Saving...'), success: t('Saved'), error: t('Failed to save') },
        { id: 'note_save', position: width > 700 ? 'bottom-right' : 'bottom-center' }
      );
    }
  };

  return <>
    <Formik onSubmit={handleSubmitEntry} initialValues={{ title: '', content: '' }}>
      <Form className="joyride-notes flex flex-col gap-5 pt-5">
        <label htmlFor="title">
          <div className="flex h-10 items-center justify-between">
            <span className="text-2xl/4 leading-7 font-bold text-gray-600">{t("Title")}</span>
          </div>
          <Field
            id="title"
            name="title"
            placeholder="Optional"
            value={title}
            className="focus:ring-pdteal mt-3 h-1/2 w-full rounded-md border border-gray-400 p-3 focus:ring focus:outline-none"
            onChange={e => setTitle(e.target.value)}
          />
        </label>
        <label htmlFor="content">
          <span className="text-2xl leading-7 font-bold text-gray-600">{t("Content")}</span>
          <Field
            as="textarea"
            rows="10"
            id="content"
            value={content}
            name="content"
            onChange={e => setContent(e.target.value)}
            className="focus:ring-pdteal mt-3 w-full rounded-md border border-gray-400 p-3 font-normal focus:ring focus:outline-none"
          />
        </label>
        <Button type="submit" className="w-full md:w-3/4 mx-auto">{t("Save")}</Button>
      </Form>
    </Formik>
    <PreviousNoteGroup
      user={props.user}
      creditId={props.creditId}
      lastSubmit={lastSubmit}
      newNoteClick={handleClearNote}
      setSelectedEntry={handleSelectEntry}
    ></PreviousNoteGroup>
  </>;
}